import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { createProjectTimelineStrategy } from '../../../../actions/projectTimelineActions'
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';

const StrategyForm = (props) => {

    const dispatch = useDispatch();
    const [members, setMembers] = useState([]);
    const [inputProjectId, setInputProjectId] = useState("");

    const validationSchema = yup.object().shape({
        strategyId: yup.string().required("Manager is required"),
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    });

    useEffect(() => {
        if (props.data) {
            setInputProjectId(props.data?.id)
            setMembers(props?.members)
        }
    }, [props.data, props.members]);

    const onMemberSubmit = async (values, e) => {
        const formData = {
            project_id: inputProjectId.toString(),
            id: values.strategyId,
        }
        // console.log(formData)
       dispatch(createProjectTimelineStrategy(formData))
    }

    return (
        <>
            <h6 htmlFor="title" className="control-label"><strong>Timeline Managers</strong></h6>
            <form className="form-auth-small" onSubmit={handleSubmit(onMemberSubmit)}>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="title" className="control-label">Select Timeline Manager<span className='text-danger'>*</span></label>
                            <select name="title" id="title"
                                {...register('strategyId', { required: "Owner is required" })}
                                className="form-control">
                                <option value=''>Select</option>
                                {members && members.map((member, index) => (
                                    <option key={index} value={member.id}>{member.name}</option>
                                ))}
                            </select>
                            {errors.strategyId && (
                                <div className="text-danger pt-2">{errors.strategyId.message}</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 col-lg-12 col-sm-12 mt-3'>
                        <button className='btn custum-bg-warning col-12 p-2 text-white'><strong>Add Timeline Manager </strong></button>
                    </div>
                </div>
            </form>
        </>
    );
};
export default StrategyForm;